import { Column, Row, Spinner } from 'hatch-components';
import styled from 'styled-components';

import { LEFT_COLUMN_WIDTH } from './components/DefaultTemplateLeftColumn/styles';

export const LOGGED_IN_HEADER_HEIGHT = 64;

export const DefaultTemplateOverflowWrapper = styled(Column)(
  ({
    theme: {
      windowSize: { height },
      responsive: { mobile, tablet },
    },
  }) => ({
    flexGrow: 0,
    flexShink: 0,
    height: '100vh',
    [mobile]: {
      height,
    },
    overflow: 'hidden',
    position: 'relative',
    [tablet]: {
      height,
    },
    width: '100vw',
  }),
);

export const DefaultTemplateContainer = styled(Row)(
  ({
    expanded,
    theme: {
      responsive: { mobile },
    },
  }) => {
    const left = expanded ? '0' : `-${LEFT_COLUMN_WIDTH}px`;

    return {
      bottom: 0,
      flexGrow: 0,
      flexShrink: 0,
      flexWrap: 'nowrap',
      height: '100%',
      left: 0,
      [mobile]: {
        '-webkit-overflow-scrolling': 'touch',
        left,
        transition: 'left 0.25s ease',
        width: `calc(100vw + ${LEFT_COLUMN_WIDTH}px)`,
      },
      overflow: 'hidden',
      position: 'absolute',
      width: '100vw',
    };
  },
);

export const DefaultTemplateMainColumn = styled(Column)(
  ({
    theme: {
      responsive: { mobile },
    },
  }) => ({
    flexGrow: 0,
    flexShrink: 0,
    height: '100%',
    [mobile]: {
      width: '100vw',
    },
    overflow: 'hidden',
    width: `calc(100vw - ${LEFT_COLUMN_WIDTH}px)`,
  }),
);

export const DefaultTemplateMainSection = styled(Column)(
  ({
    padding,
    theme: {
      spacing,
      colors: { backgroundGrey },
      responsive: { mobile },
    },
  }) => ({
    background: backgroundGrey,
    flexGrow: 0,
    flexShrink: 0,
    flexWrap: 'nowrap',
    height: `calc(100% - ${LOGGED_IN_HEADER_HEIGHT}px)`,
    [mobile]: {
      width: '100%',
    },
    overflow: 'hidden',
    overflowY: 'auto',
    padding: padding !== undefined ? `${padding}px` : spacing.md,
    position: 'relative',
    width: '100%',
  }),
);

export const MobileExpandedTouchTarget = styled.div(
  ({
    expanded,
    theme: {
      colors,
      responsive: { mobile },
    },
  }) => {
    return {
      display: 'none',
      [mobile]: {
        background: colors.backdrop,
        display: expanded ? 'flex' : 'none',
        flexGrow: 0,
        flexShrink: 0,
        height: '100%',
        left: LEFT_COLUMN_WIDTH,
        overflow: 'hidden',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: 9999,
      },
    };
  },
);

export const StyledSpinnerWrapper = styled(Column)(() => ({
  alignItems: 'center',
  height: '100vh',
  justifyContent: 'center',
  width: '100vw',
}));

export const StyledSpinner = styled(Spinner)(() => ({
  height: 96,
  width: 96,
}));
